import { z } from "zod";

export const backofficeFindSitePhotoResponseSchema = z.instanceof(Blob);

export type BackofficeFindSitePhotoResponse = z.infer<typeof backofficeFindSitePhotoResponseSchema>;
